module.exports = __webpack_public_path__ + "static/media/silownia.54811e33.jpg";